





























import {Vue, Component} from "vue-property-decorator";
import {MutationList as modalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class Modal extends Vue {
    private modalNamespace = 'modal/';


    /*
    * Header for message
    * Error, push etc.
    * */
    get getModalHeaderMessage(): string {
        return this.$store.getters[`${this.modalNamespace}getHeaderMessage`]
    }

    /*
    * Modal message
    * ex. Error, Push notification etc.
    * */
    get getModalMessage(): string {
        return this.$store.getters[`${this.modalNamespace}getMessage`];
    }

    // loading screen message (under loading roller)
    get getModalFooterMessage(): string {
        return this.$store.getters[`${this.modalNamespace}getFooterMessage`]
    }

    /*
    * Modal types
    * 0 - error message
    * not 0 - Loading modal
    * */
    get getModalType(): number {
        return this.$store.getters[`${this.modalNamespace}getType`];
    }

    get visible(): boolean {
        return this.$store.getters[`${this.modalNamespace}isVisible`]
    }

    closeMessage() {
        this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
    }
}
